<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <mat-tab-group
    mat-align-tabs="center"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    [selectedIndex]="ViewTab.value"
    (selectedIndexChange)="ViewTab.setValue($event)"
  >
    <mat-tab label="Search containers" [disabled]="isSelected(0)">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>From</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              (dateInput)="addEventfrom('input', $event)"
              (dateChange)="addEventfrom('change', $event)"
              [value]="date2.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>To</mat-label>
            <input
              matInput
              [matDatepicker]="picker2"
              (dateInput)="addEventto('input', $event)"
              (dateChange)="addEventto('change', $event)"
              [value]="date.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2 color="primary"></mat-datepicker>
          </mat-form-field>

          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            style="margin-top: 16px"
          >
            <mat-slide-toggle
              [(ngModel)]="checked"
              class="example-margin"
              [checked]="checked"
            >
              Active ?
            </mat-slide-toggle>
          </div>
          <div
            class="
              example-button-container
              col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2
            "
            style="margin-top: 13px; margin-right: 0px"
          >
            <button
              (click)="OnViewContainer()"
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="primary"
            >
              Search
            </button>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Search</mat-label>
          <input
            matInput
            (keyup)="applyFilterSearch($event)"
            placeholder="Search"
            #dataSearch
          />
          <button
            mat-button
            matSuffix
            mat-icon-button
            color="primary"
            (click)="openDialogLector()"
            aria-label="Example icon button with a menu icon"
          >
            <mat-icon>qr_code_scanner</mat-icon>
          </button>
          <mat-hint>Filter table</mat-hint>
        </mat-form-field>
          <div
            class="
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
   
            <div
              class="example-loading-shade"
              *ngIf="isLoadingResults || isRateLimitReached"
            >
              <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
              <div
                class="example-rate-limit-reached"
                *ngIf="isRateLimitReached"
              >
                Without Container
              </div>
            </div>
         
            <div class="example-table-container" #exportExcel>
              <button
              mat-button
              matSuffix
              mat-icon-button
              color="success"
              (click)="exportAsExcel()"
              aria-label="Example icon button with a menu icon"
              class="col-md-12"
            >Excel
          
              <mat-icon>cloud_download</mat-icon>
            </button>
              <table
                mat-table
                [dataSource]="datasourceConteiner"
                class="example-table"
                matSort
                matSortActive="created"
                matSortDisableClear
                matSortDirection="desc"
                #tablematSort="matSort"
              >
                <!-- Number Column -->
                <ng-container matColumnDef="Options" sticky>
                  <th mat-header-cell *matHeaderCellDef>Options</th>
                  <td mat-cell *matCellDef="let row">


                    <button mat-icon-button [matMenuTriggerFor]="menuCon" aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuCon="matMenu">
                      <button  (click)="OnEditarContainer(row)" mat-menu-item>
                       
                        <span>Edit</span>
                      </button>
                     
                      <button   (click)="OnConfirmItemsContainer(row)" mat-menu-item>
                   
                        <span>Confirm Items</span>
                      </button>
                    </mat-menu>
                    
                 
                  </td>
                </ng-container>

                <!-- Title Column -->
                <ng-container matColumnDef="Customer">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Company Name</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{onCleaarte(row.Customer)}}</div>
                   
                  </td>
                </ng-container>

                <!-- State Column -->
                <ng-container matColumnDef="Container">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Container</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.ContainerNumber}}</div>
                   
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="References">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Reference #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.ReferenceNumber}}</div>
                  
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Arrived">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Arrived</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Arrived }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Empty">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Empty</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Empty }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Departed">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Departed</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Departed }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Location">
                  <th mat-header-cell *matHeaderCellDef>Location</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.Location}}</div>

                
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Pieces">
                  <th mat-header-cell *matHeaderCellDef>Pieces</th>
                  <td mat-cell *matCellDef="let row">{{ row.Pieces }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Available">
                  <th mat-header-cell *matHeaderCellDef>Available</th>
                  <td mat-cell *matCellDef="let row">{{ row.Available }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let row">{{ row.Status }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Active">
                  <th mat-header-cell *matHeaderCellDef>Active</th>
                  <td mat-cell *matCellDef="let row">{{ row.Active }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Notes" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef>Notes</th>
                  <td mat-cell *matCellDef="let row">{{ row.Notes }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
          <mat-paginator
            [length]="resultsLength"
            [pageSizeOptions]="[5, 10, 25, 100]"
            matPaginator
            #tablePaginator="matPaginator"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Add container" [disabled]="isSelected(1)">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <form [formGroup]="ContainerForm">
          <mat-form-field
            appearance="fill"
            hintLabel="Company Name"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Select An Option</mat-label>
            <mat-select formControlName="custom">
              <mat-option
                *ngFor="let customer of CustomerView"
                [value]="customer.key"
                >{{ customer.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 11 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Container #</mat-label>
            <input
              matInput
              #container
              maxlength="11"
              placeholder="Container #"
              formControlName="contenedor"
            />
            <mat-hint align="end"
              >{{ container.value?.length || 0 }}/11</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 10 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Reference #</mat-label>
            <input
              matInput
              #references
              maxlength="250"
              placeholder="Reference #"
              formControlName="referencia"
            />
            <mat-hint align="end"
              >{{ references.value?.length || 0 }}/250 max</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Arrived</mat-label>
            <input
              matInput
              [matDatepicker]="arrivedDate"
              (dateInput)="addEventfrom('input', $event)"
              (dateChange)="addEventfrom('change', $event)"
              formControlName="arrived"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="arrivedDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #arrivedDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
            *ngIf="isLDT"
          >
            <mat-label>Empty</mat-label>
            <input
              matInput
              [matDatepicker]="emptyDate"
              (dateInput)="addEventfrom('input', $event)"
              (dateChange)="addEventfrom('change', $event)"
              formControlName="empty"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emptyDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #emptyDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
            *ngIf="isLDT"
          >
            <mat-label>Departed</mat-label>
            <input
              matInput
              [matDatepicker]="departedDate"
              (dateInput)="addEventfrom('input', $event)"
              (dateChange)="addEventfrom('change', $event)"
              formControlName="departed"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="departedDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #departedDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Status</mat-label>
            <mat-select formControlName="estatus">
              <mat-option
                *ngFor="let estats of ArrayEstatusContenedor"
                [value]="estats.key"
                >{{ estats.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 150 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Location</mat-label>
            <input
              matInput
              #container
              maxlength="150"
              placeholder="Location"
              formControlName="location"
            />
            <mat-hint align="end"
              >{{ container.value?.length || 0 }}/150</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Total</mat-label>
            <input
              matInput
              type="number"
              placeholder="Total"
              min="1"
              formControlName="total"
            />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Available</mat-label>
            <input
              matInput
              type="number"
              placeholder="Available"
              min="1"
              formControlName="available"
            />
          </mat-form-field>
          <mat-checkbox
            class="
              example-margin
              col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3
            "
            
            formControlName="actived"
            >Active?</mat-checkbox
          >
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes"></textarea>
          </mat-form-field>

          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              btn-group
            "
          >
            <button
              mat-raised-button
              color="warn"
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              (click)="OnCancel()"
              *ngIf="editar"
            >
              Cancel
            </button>
            <button
              mat-raised-button
              color="primary"
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              (click)="OnNewContainer(0)"
              *ngIf="!editar"
            >
              Add
            </button>
            <button
              mat-raised-button
              color="primary"
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              (click)="OnNewContainer(update)"
              *ngIf="editar"
            >
              Save
            </button>
          </div>
        </form>

<div style="margin-top: 2vh;" *ngIf="editar" class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormItemsContainer">
  <mat-form-field
  appearance="fill"
  class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
  <mat-label>item Number</mat-label>
  <input
    matInput
    type="text"
    placeholder="itemNumber"
  
    formControlName="itemNumber"
  />
</mat-form-field>
<mat-form-field
appearance="fill"
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-label>PO#</mat-label>
<input
  matInput
  type="text"
  placeholder="PO#"

  formControlName="proNumber"
/>
</mat-form-field>
<mat-form-field
appearance="fill"
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-label>Quantity</mat-label>
<input
  matInput
  type="number"
  placeholder="Quantity"
  min="1"
  formControlName="quantity"
/>
</mat-form-field>
<mat-form-field
appearance="fill"
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-label>Pallet</mat-label>
<input
  matInput
  type="number"
  placeholder="Pallet"
  min="1"
  formControlName="pallet"
/>
</mat-form-field>
<mat-form-field
appearance="fill"
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-label>Weight</mat-label>
<input
  matInput
  type="number"
  placeholder="Weight"
  min="1"
  formControlName="weight"
/>
</mat-form-field>
<button
mat-raised-button
color="primary"
class="
  col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2
"
style="height: 6vh"
(click)="onAddItemsContainer()"
*ngIf="!viewEditItemsContainer"
>
Add
</button>
<button
mat-raised-button
color="primary"
class="
  col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2
"
style="height: 6vh"
(click)="onUpdateItemsContainer()"
*ngIf="viewEditItemsContainer"
>
Update
</button>
<div class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="
height: 40vh !important;
overflow: auto;margin-top: 2vh;
">
  <table class="table table-bordered" *ngIf="viewTable" style="width: 100% !important">
  <thead>
    <tr>
      <th>Options</th>
      <th>Item Number</th>
      <th>Quantity</th>
      <th>Pallet</th>
      <th *ngIf="false">Weight</th>
       <th>PO#</th>
       <th>Received</th>
       <th>Status</th>
    </tr>
    
  </thead>
  <tbody>
    <tr *ngFor="let item of arrayItemsContainer; let i=index">
<td>
  <button mat-icon-button [matMenuTriggerFor]="menuIt" aria-label="Example icon-button with a menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menuIt="matMenu">
    <button (click)="OnEditarItemsContainer(item)" mat-menu-item>
      
      <span>Edit</span>
    </button>
  
    <button (click)="OnDeleteItemsContainer(item)" mat-menu-item>
     
      <span>Delete</span>
    </button>
  </mat-menu>
  

</td>
<td>{{item.ItemNumber}}</td>
<td>{{item.Quantity}}</td>
<td>{{item.palletQuantity}}</td>
<td *ngIf="false">{{item.weightTotal}}</td>
<td>{{item.proNumber}}</td>
<td>{{item.receiveQuantity}}</td>
<td><p *ngIf="item.Active==1">PENDING CONFIRMATION</p>
  <p *ngIf="item.Active==2">CONFIRMED</p></td>
    </tr>
  </tbody>
  </table>
</div>

</div>


      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
